import { render, staticRenderFns } from "./vodaDuplicateDogovor.vue?vue&type=template&id=366c8065"
import script from "./vodaDuplicateDogovor.vue?vue&type=script&lang=js"
export * from "./vodaDuplicateDogovor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports